module.exports = __webpack_public_path__ + "img/logo.c8d6d591.svg";